import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { subscriptionService } from "../service/SubscriptionService";

const SubscriptionUpgrade = () => {
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);

  const handleUpgradeClick = async () => {
    setLoading(true);
    try {
      const { url } = await subscriptionService.getPaymentLink();
      window.location.href = url;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Une erreur inattendue s'est produite";
      toast.current?.show({
        severity: "error",
        summary: "Erreur",
        detail: errorMessage,
        life: 5000,
        contentClassName: "bg-red-500 text-white",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto mt-24 px-4 font-sans flex-1">
      <Toast ref={toast} />
      <Card title="Mettre à niveau votre abonnement" className="bg-white rounded-lg shadow-lg font-sans text-center">
        <div className="text-center mb-8 p-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold mb-2">Plan Premium</h3>
          <div className="text-4xl font-bold text-blue-500 my-4">€30/an</div>
          <ul className="my-6 space-y-2">
            <li className="flex items-center justify-center text-gray-600 py-2">
              <span className="text-green-500 mr-2">✓</span>
              Accès illimité à toutes les fonctionnalités
            </li>
            <li className="flex items-center justify-center text-gray-600 py-2">
              <span className="text-green-500 mr-2">✓</span>
              Support prioritaire
            </li>
            <li className="flex items-center justify-center text-gray-600 py-2">
              <span className="text-green-500 mr-2">✓</span>
              Analyses avancées
            </li>
            <li className="flex items-center justify-center text-gray-600 py-2">
              <span className="text-green-500 mr-2">✓</span>
              Personnalisation de la marque
            </li>
          </ul>
        </div>
        <Button
          onClick={handleUpgradeClick}
          disabled={loading}
          className="w-full h-12 justify-center font-semibold text-xl rounded-lg font-sans mt-4 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-center transition-transform hover:translate-y-[-1px] hover:shadow-lg disabled:opacity-80 disabled:cursor-not-allowed"
          loading={loading}
        >
          {loading ? "Traitement en cours..." : "Mettre à niveau l'abonnement"}
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionUpgrade;
